module.exports = __webpack_public_path__ + "static/anim-leads-2272c485bf0794e56b030d9f1a4761e4.mp4";